var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m32 8c-13.255 0-24 10.745-24 24h-2l4 6 4-6h-2c0-11.028 8.972-20 20-20 9.138 0 16.847 6.168 19.227 14.554l2.77-4.155c-3.704-8.474-12.157-14.399-21.997-14.399z",
    fill: "#fa6450"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m34 12c-.306 0-.604.032-.907.046 8.654.471 15.85 6.46 18.134 14.508l1.313-1.97c-2.953-7.361-10.136-12.584-18.54-12.584z",
    fill: "#dc4632"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m32.805 8.03c-.268-.009-.534-.03-.805-.03-13.255 0-24 10.745-24 24h2c0-12.854 10.106-23.347 22.805-23.97z",
    fill: "#dc4632"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m8 32h-2l4 6 1-1.5z",
    fill: "#dc4632"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m54 26-4 6h2c0 11.028-8.972 20-20 20-9.138 0-16.847-6.168-19.227-14.554l-2.77 4.155c3.704 8.474 12.157 14.399 21.997 14.399 13.255 0 24-10.745 24-24h2z",
    fill: "#64c8f0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m53.997 32h-1.997c0 10.722-8.488 19.476-19.094 19.954.362.02.723.046 1.091.046 11.028 0 20-8.972 20-20z",
    fill: "#46aad2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12 41.601 1.459-2.188c-.257-.642-.495-1.294-.685-1.967l-2.77 4.155c3.703 8.474 12.156 14.399 21.996 14.399.4 0 .798-.011 1.193-.03-9.493-.314-17.591-6.128-21.193-14.369z",
    fill: "#46aad2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m54 26-4 6h1.997l3.001-4.502z",
    fill: "#46aad2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m32 36c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10z",
    fill: "#fab400"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 26,
    fill: "#be7800",
    r: 6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24 26c0-5.185 3.947-9.448 9-9.95-.329-.032-.662-.05-1-.05-5.523 0-10 4.477-10 10s4.477 10 10 10c.338 0 .671-.018 1-.05-5.053-.502-9-4.765-9-9.95z",
    fill: "#dc9600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m34 23.857v-1.428h-1.333v-1.429h-1.334v1.429h-1.333v4.285h2.667v1.429h-2.667v1.428h1.333v1.429h1.334v-1.429h1.333v-4.285h-2.667v-1.429z",
    fill: "#fab400"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23 40h18c.552 0 1-.448 1-1v-2c0-.552-.448-1-1-1h-18c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1z",
    fill: "#fab400"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41 38h-18c-.552 0-1-.448-1-1v2c0 .552.448 1 1 1h18c.552 0 1-.448 1-1v-2c0 .552-.448 1-1 1z",
    fill: "#dc9600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23 44h18c.552 0 1-.448 1-1v-2c0-.552-.448-1-1-1h-18c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1z",
    fill: "#fab400"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23 48h18c.552 0 1-.448 1-1v-2c0-.552-.448-1-1-1h-18c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1z",
    fill: "#fab400"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41 42h-18c-.552 0-1-.448-1-1v2c0 .552.448 1 1 1h18c.552 0 1-.448 1-1v-2c0 .552-.448 1-1 1z",
    fill: "#dc9600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41 46h-18c-.552 0-1-.448-1-1v2c0 .552.448 1 1 1h18c.552 0 1-.448 1-1v-2c0 .552-.448 1-1 1z",
    fill: "#dc9600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24 39v-2c0-.552.448-1 1-1h-2c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1h2c-.552 0-1-.448-1-1z",
    fill: "#dc9600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24 43v-2c0-.552.448-1 1-1h-2c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1h2c-.552 0-1-.448-1-1z",
    fill: "#dc9600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24 47v-2c0-.552.448-1 1-1h-2c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1h2c-.552 0-1-.448-1-1z",
    fill: "#dc9600"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurring);
export default __webpack_public_path__ + "static/media/recurring.269f3e506b2ec48665b92fbf62b06b95.svg";
export { ForwardRef as ReactComponent };